import React, { useEffect, useState, Suspense} from 'react'
import './App.scss'
import Portal from './Portal'

import {
  PlaceMap,
  PremadeSearchWithResultsForm,
  QuickSearchNoResultsForm,
  QuickSearchWithResultsForm,
  SearchWidgetGenerator,
} from './components'
import { useI18n } from '@ggs/i18n'
import { get } from 'lodash'

/**
 * React application components initialization.
 * @return {JSX.Element}
 */
function App() {
  const { changeLanguage } = useI18n()
  const [languageReady, setLanguageReady] = useState(false)
  const languageCode = get(window || {}, 'drupalSettings.path.currentLanguage', 'en')

  useEffect(() => {
    changeLanguage(languageCode)
    setLanguageReady(true)
  }, [languageCode])

  // Wait that language resolution is done before rendering components.
  if (!languageReady) {
    return null
  }

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <div className="App">
        <Portal containerId={'search-with-results'}>
          <QuickSearchWithResultsForm />
        </Portal>
        <Portal containerId={'search-no-results'}>
          <QuickSearchNoResultsForm />
        </Portal>
        <Portal containerId={'search-result-map'}>
          <PlaceMap />
        </Portal>
        <Portal containerId={'search-widget'}>
          <QuickSearchNoResultsForm embed={true} />
        </Portal>
        <Portal containerId={'widget-code-generator'}>
          <SearchWidgetGenerator />
        </Portal>
        <Portal containerId={'premade-search'}>
          <PremadeSearchWithResultsForm />
        </Portal>
      </div>
    </Suspense>
  )
}

export default App
